import React, { useEffect, useState } from 'react'
import Button3D from './Button3D'
import apng from '../img/APNG.png'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

export default function About(animation) {
	const controls = useAnimation()
	const { ref, inView } = useInView({ threshold: 0.3 })
	const { animation: aniprops } = animation

	useEffect(() => {
		if (inView) {
			controls.start('visible')
		}
		if (!inView) {
			controls.start('hidden')
		}
	}, [controls, inView])
	return (
		<section ref={ref} className='about section' id='about'>
			<motion.div
				initial='hidden'
				animate={controls}
				variants={aniprops}
				className='wrapper'
			>
				<span className='section__subtitle'>My intro</span>
				<h2 className='section__title'>About me</h2>
				<div className='about__container container grid'>
					<img src={apng + '?' + Math.random()} alt='' className='about__img' />
					<div className='about__data'>
						<div className='about__info'>
							<div className='about__box'>
								<i className='bx bx-award about__icon'></i>
								<h3 className='about__title'>Experience</h3>
								<span className='about__subtitle'>3 Year </span>
							</div>

							<div className='about__box'>
								<i className='bx bx-support about__icon'></i>
								<h3 className='about__title'>Support</h3>
								<span className='about__subtitle'>Online 24/7</span>
							</div>
						</div>
						<p className='about__description'>
							<b>Web Developer & Graphic Designer </b> with 3+ years experience
							in front-end development, IT support, and digital marketing.
							Skilled at building responsive websites, integrating 3D elements,
							and managing CRM platforms to deliver user-focused digital
							experiences.
						</p>
						<div className='about__button'>
							<Button3D props={{ href: '#contact', content: 'Contact me' }} />
						</div>
					</div>
				</div>
			</motion.div>
		</section>
	)
}
